import React, { memo } from 'react';

import { type TextReadContent } from './text-read-content.ts';
import styles from './text-value-view.module.css';

/**
 * Stateless plain projection; consumers supply frames and empty-value placeholders.
 * This presenter does not claim parity with the V1 rich-text resource renderer.
 */
export const TextValueView = memo(function TextValueView({
  content,
  showDisabledValue = false
}: {
  readonly content: TextReadContent;
  readonly showDisabledValue?: boolean;
}) {
  if (!content.text) {
    return null;
  }

  return (
    <span className={styles.value} data-disabled={showDisabledValue || undefined}>
      {content.text}
    </span>
  );
});
